<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div
        v-if="showError"
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
        v-bind:style="background_image"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
          <b-card>
            <h4>{{ $t("AppError") }}</h4>
          </b-card>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import $ from "jquery";
import { setUserAppUuid, setAppUuid, setCurrentUserId, getErrorMessage } from "@/utils/helper";
import { appointmentLogin } from '@/api/login';

export default {
  data() {
    return {
      uuid: "",
      showError: false,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  mounted() {
    this.uuid = this.$route.params.uuid;
    localStorage.setItem("uuid", this.uuid);
    setAppUuid(this.uuid);
    this.checkAppStatus();
  },
  watch:{
    background_image: function(newValue) {},
  },
  computed: {
    background_image(){
        return {'background-image' : "url("+this.$store.getters.whitelabel.background_image.path + ")"};
    }
 },
  methods: {
    async appointmentLogin(uuid) {
      const res = await appointmentLogin(uuid);
      if(res.data.token && res.data.user_id) {
        sessionStorage.setItem(`APPOINTMENT-LOGIN-${uuid}`, res.data.token);
        sessionStorage.setItem(`APPOINTMENT-LOGIN-USERID`, res.data.user_id);
      }
    },

    /**
     * check room availablity
     */
    async checkAppStatus() {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      try{
        const res = await this.$store.dispatch("GetAppointmentByUuid", this.uuid)
        this.show = false;
        var param = null;
        if (res.data.data.conference_uuid) {
          setUserAppUuid(res.data.data.conference_uuid);
          param = res.data.data.conference_uuid;
        } else {
          setUserAppUuid(res.data.data.uuid);
          param = res.data.data.uuid;
        }
  
        setCurrentUserId(res.data.data.user_id);
  
        if (res.data.data.is_premium && res.data.data.payment_status != 1) {
          this.$router.push({ path: "/appointmentpay/" + this.uuid });
        } 
        else if(res.data.data.type != 'walkin' && res.data.data.is_confirmed != 1){
          window.alert('Appointment is not confirmed yet.');
          if(window.opener) {
            const goBack = window.open('', `USER-APPOINTMENT-${res.data.data.uuid}`);
            goBack && goBack.focus();
          }
          window.close();
        }else {
          await this.appointmentLogin(this.uuid);
          window.location.href = res.data.data.room_link + "?key=" + btoa(param + "&" + this.uuid);           
        }
      }catch(e) {
        console.error(e);
        this.$log.error(
          "src/frontend/Conference.vue | Function : checkAppStatus()",
          error
        );
        this.showError = true;
        this.show = false;
        // Error response
        this.error = getErrorMessage(error, this);
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        return false;
      }
    },
  },
};
</script>